import React from 'react';
import './BecomeParent.scss';
import { safeHtml } from '../../../../services/helpers';
import StrapiImageWithSkeleton from '../../../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';

export default function BecomeParent({ content }) {
    return (
        <div className='workshop-become_parent'>
            <div className='workshop-become_parent__content'>
                <div className="workshop-become_parent__text" dangerouslySetInnerHTML={safeHtml(content.Texte)} />
                <div className="workshop-become_parent__image-container">
                    <div className="workshop-become_parent__image-wrapper">
                        <StrapiImageWithSkeleton
                            picture={content.Photo}
                            loading="lazy"
                            size='thumbnail'
                        />
                    </div>
                    <div className="workshop-become_parent__image-shadow"></div>
                </div>
            </div>
        </div>
    )
}